var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline"},[_c('div',{staticClass:"badge badge-primary"},[_vm._v(_vm._s(_vm.formatAgencyStatus(_vm.agency.status)))]),_c('span',{staticClass:"font-small-3"},[_vm._v(" "+_vm._s(_vm.endsAt))])])}
var staticRenderFns = []

export { render, staticRenderFns }